import { render, staticRenderFns } from "./products.edit.component.vue?vue&type=template&id=2ad20929&scoped=true&"
import script from "./products.edit.component.vue?vue&type=script&lang=js&"
export * from "./products.edit.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad20929",
  null
  
)

export default component.exports